import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [showWeChatModal, setShowWeChatModal] = useState(false);

  const footerLinks = {
    products: [
      { name: 'Adobe PDF Library SDK', path: '/adobe-pdf-library' },
      { name: 'Adobe PDF Converter', path: '/adobe-pdf-converter' },
      { name: 'PDF Form Extension SDK', path: '/pdf-forms-extension-sdk' },
      { name: 'pdfRest API Toolkit', path: '/pdf-rest-container' }
    ],
    company: [
      { name: '关于我们', path: '/about' },
      { name: '客户案例', path: '/cases' },
      { name: '资源中心', path: '/resources' },
      { name: '加入我们', path: '/careers' }
    ],
    support: [
      { name: '帮助中心', path: '/help' },
      { name: '系统状态', path: '/status' },
      { name: '安全中心', path: '/security' },
      { name: '联系我们', path: '/contact' }
    ],
    legal: [
      { name: '隐私政策', path: '/privacy' },
      { name: '服务条款', path: '/terms' },
      { name: '最终用户许可协议', path: '/eula' }
    ]
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-gray-300" role="contentinfo">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          <div className="lg:col-span-1">
            <h3 className="text-2xl font-bold text-white mb-4">星允信息</h3>
            <div className="space-y-3 mb-6">
              <a href="tel:400-838-9650" className="flex items-center text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                <i className="ri-phone-line text-xl mr-3" aria-hidden="true"></i>
                <span>400-838-9650</span>
              </a>
              <a href="mailto:hello@documogul.com" className="flex items-center text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                <i className="ri-mail-line text-xl mr-3" aria-hidden="true"></i>
                <span>hello@documogul.com</span>
              </a>
            </div>
            <nav className="flex gap-4" aria-label="社交媒体链接">
              <a 
                href="https://github.com/datalogics" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-lg bg-gray-800 hover:bg-teal-600 transition-colors cursor-pointer"
                aria-label="访问我们的GitHub"
              >
                <i className="ri-github-fill text-xl" aria-hidden="true"></i>
              </a>
              <button
                onClick={() => setShowWeChatModal(true)}
                className="w-10 h-10 flex items-center justify-center rounded-lg bg-gray-800 hover:bg-teal-600 transition-colors cursor-pointer"
                aria-label="查看微信公众号二维码"
              >
                <i className="ri-wechat-fill text-xl" aria-hidden="true"></i>
              </button>
            </nav>
          </div>

          <nav className="lg:col-span-1" aria-labelledby="products-heading">
            <h4 id="products-heading" className="text-white font-semibold mb-4 text-lg">
              <a href="#products" className="hover:text-teal-400 transition-colors">产品服务</a>
            </h4>
            <ul className="space-y-3">
              {footerLinks.products.map((link, index) => (
                <li key={index}>
                  <Link 
                    to={link.path}
                    className="hover:text-teal-400 transition-colors cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav className="lg:col-span-1" aria-labelledby="company-heading">
            <h4 id="company-heading" className="text-white font-semibold mb-4 text-lg">
              <a href="#company" className="hover:text-teal-400 transition-colors">公司信息</a>
            </h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link, index) => (
                <li key={index}>
                  <Link 
                    to={link.path}
                    className="hover:text-teal-400 transition-colors cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav className="lg:col-span-1" aria-labelledby="support-heading">
            <h4 id="support-heading" className="text-white font-semibold mb-4 text-lg">
              <a href="#support" className="hover:text-teal-400 transition-colors">支持与帮助</a>
            </h4>
            <ul className="space-y-3">
              {footerLinks.support.map((link, index) => (
                <li key={index}>
                  <Link 
                    to={link.path}
                    className="hover:text-teal-400 transition-colors cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav className="lg:col-span-1" aria-labelledby="legal-heading">
            <h4 id="legal-heading" className="text-white font-semibold mb-4 text-lg">
              <a href="#legal" className="hover:text-teal-400 transition-colors">法律信息</a>
            </h4>
            <ul className="space-y-3">
              {footerLinks.legal.map((link, index) => (
                <li key={index}>
                  <Link 
                    to={link.path}
                    className="hover:text-teal-400 transition-colors cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <p className="text-gray-400 text-sm">
            © 2026 广州星允信息技术有限公司. 保留所有权利.
          </p>
        </div>
      </div>

      {showWeChatModal && (
        <div 
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
          onClick={() => setShowWeChatModal(false)}
          role="dialog"
          aria-modal="true"
          aria-labelledby="wechat-modal-title"
        >
          <div 
            className="bg-white rounded-2xl p-8 max-w-sm w-full relative"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setShowWeChatModal(false)}
              className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors cursor-pointer"
              aria-label="关闭弹窗"
            >
              <i className="ri-close-line text-xl text-gray-600" aria-hidden="true"></i>
            </button>
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-teal-500 to-cyan-500 rounded-2xl mx-auto mb-4">
                <i className="ri-wechat-fill text-3xl text-white" aria-hidden="true"></i>
              </div>
              <h3 id="wechat-modal-title" className="text-2xl font-bold text-gray-900 mb-2">关注我们的公众号</h3>
              <p className="text-gray-600 mb-6">扫描二维码关注获取最新资讯</p>
              <img 
                src="https://static.readdy.ai/image/8dfcde88d6d872f7d495e2c3222a324c/24a3e17d299d19953469e820a3f2ff08.jpeg"
                alt="星允信息微信公众号二维码"
                title="扫描关注星允信息公众号"
                className="w-64 h-64 mx-auto rounded-lg"
              />
            </div>
          </div>
        </div>
      )}
    </footer>
  );
}